













































































































import { PropType } from 'vue';
import { computed, defineComponent, ref, nextTick, watch, toRefs } from '@vue/composition-api';
import YellowLightImg from '@tt4b/ttam-assets/src/images/creative/yellow-light.png';
import TreeNodeHoverEstimatePopover from '@/components/common/tree-node-hover-estimate-popover/index.vue';
// import { useABTest } from '@/hooks/account/useABTest';
import { calcVisibleTagCount, defaultVisibleTagCount } from '../utils/index';
import { useTargetRecommendClickable } from '../hooks/use-recommend-target';
import { AdgroupFormData, CampaignFormData, NodeHoverContentType } from '@tt4b/ttam-enums';
export default defineComponent({
  name: 'RecommendTarget',
  components: { TreeNodeHoverEstimatePopover },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { adgroupData, campaignData } = toRefs(props);
    const { itemCount, recommendFlattenData, selectOneTag, selectAll } = useTargetRecommendClickable({
      ctx,
      adgroupData,
      campaignData,
    });

    const visibleTagCount = ref(defaultVisibleTagCount);
    const tagsNode = ref<HTMLElement>();
    const tagsNodeArr = ref<HTMLElement[]>();
    const isShowAll = ref(false);

    const isShowAllBtnDisplay = computed(() => itemCount.value - visibleTagCount.value > 0);

    function selectAllTags() {
      isShowAll.value = false;
      selectAll();
    }

    watch(
      () => recommendFlattenData.value.length,
      () =>
        nextTick(() => {
          visibleTagCount.value = calcVisibleTagCount(tagsNode.value, tagsNodeArr.value, 16);
        }),
      { immediate: true },
    );

    return {
      tagsNode,
      tagsNodeArr,
      selectOneTag,
      selectAllTags,
      itemCount,
      recommendFlattenData,
      visibleTagCount,
      isShowAllBtnDisplay,
      isShowAll,
      NodeHoverContentType,
      YellowLightImg,
    };
  },
});
